import {
  Settings,
  Tool,
  Zap,
  Gift,
  Maximize,
  Minimize,
  Archive,
  CheckSquare,
  Key,
  Home,
  Wind,
  Edit,
  Link,
  Layers,
  Truck,
  Briefcase,
  Shield,
  Power,
  Droplet,
  Feather,
  Thermometer,
  Anchor,
  GitBranch,
  Clock,
  Calendar,
  AlertTriangle,
  ZoomIn,
  Crosshair,
  Crop,
  Edit3,
  Square,
  Scissors,
  BatteryCharging,
  Server,
} from "react-feather";

const services = [
  {
    id: 1,
    icon: Link,
    title: "Carrier Connection",
    description:
      "We connect shippers with vetted, reliable carriers while optimizing routes for maximum efficiency and cost-effectiveness.",
    category: "Core Services",
  },
  {
    id: 2,
    icon: Briefcase,
    title: "Rate Negotiation",
    description:
      "Expert negotiation of competitive rates between shippers and carriers, ensuring cost transparency and satisfaction for all parties.",
    category: "Core Services",
  },
  {
    id: 3,
    icon: Layers,
    title: "Freight Management",
    description:
      "Comprehensive freight management including load planning, real-time tracking, and documentation handling.",
    category: "Core Services",
  },
  {
    id: 4,
    icon: Shield,
    title: "Compliance & Risk Management",
    description:
      "Thorough carrier vetting and ensuring compliance with legal and insurance requirements to mitigate risks.",
    category: "Support",
  },
  {
    id: 5,
    icon: Thermometer,
    title: "Specialized Transport",
    description:
      "Handling of specialized shipments including temperature-controlled freight, oversized loads, and expedited shipping.",
    category: "Specialized",
  },
  {
    id: 6,
    icon: Server,
    title: "Technology Solutions",
    description:
      "Advanced software platforms for real-time tracking, load boards, and automated logistics processes.",
    category: "Technology",
  },
  {
    id: 7,
    icon: Tool,
    title: "Claims Assistance",
    description:
      "Professional assistance with freight claims for damage or loss, ensuring smooth resolution processes.",
    category: "Support",
  },
  {
    id: 8,
    icon: Zap,
    title: "Market Expertise",
    description:
      "Valuable insights into freight market trends, capacity availability, and seasonal variations.",
    category: "Support",
  },
];

export default services;
